import React, { useState } from 'react';
import { ethers } from 'ethers';

const CreateOfferForm = ({ contract, signer, fetchOffers }) => {
  const [points, setPoints] = useState('');
  const [ethAmount, setEthAmount] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Contract:", contract);
      console.log("Contract functions:", Object.keys(contract.functions));
      
      const tx = await contract.createOffer(points, {
        value: ethers.utils.parseEther(ethAmount)
      });
      await tx.wait();
      alert('Offer created successfully!');
      fetchOffers();
      setPoints('');
      setEthAmount('');
    } catch (error) {
      console.error('Error creating offer:', error);
      alert('Error creating offer. Please try again.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Create Offer</h2>
      <div>
        <label htmlFor="points">Number of Marks:</label>
        <input
          type="number"
          id="points"
          value={points}
          onChange={(e) => setPoints(e.target.value)}
          required
        />
      </div>
      <div>
        <label htmlFor="ethAmount">ETH Amount:</label>
        <input
          type="number"
          id="ethAmount"
          value={ethAmount}
          onChange={(e) => setEthAmount(e.target.value)}
          required
        />
      </div>
      <button className="create-offer" type="submit">Submit Offer</button>
    </form>
  );
};

export default CreateOfferForm;